const en = {
	home: {
		slogan: 'CoreCare develops unique ECG sensors and in-depth ECG and HRV analysis for Telehealth Remote Patient Monitoring market.',
		home_title: 'Handheld and Patch Type ECG Monitors For Predictive Monitoring',
		CB11_title: 'CB11',
		CB11_highlight_1: 'Light weight and simple to use.',
		CB11_highlight_2: 'Low power Bluetooth connection to iOS and Android devices.',
		CB11_highlight_3: 'Up to 15 days of continuous Mobile Cardiac Telemetry (MCT) without charging.',
		CB11_subtitle: 'Conversion To Handheld',
		CB11_highlight_4: 'CB11 patch can be easily converted to a small key chain type handheld ECG monitor, by replacing the adhesive gel electrode holder with steel electrodes.',
		CB12_title: 'CB12',
		CB12_highlight_1: 'Card-type handheld ECG monitor.',
		app_highlight: 'All sensors are compatible with iOS, Android or any other Bluetooth capable devices.',
		Covid19_title: 'COVID-19',
		Covid19_des_01: 'There is evidence that the drugs used for the treatment of COVID-19 patients result in QT interval prolongation leading to increased risk of Ventricular Fibrillation.',
		Covid19_des_02: 'Studies have also shown that COVID-19 patients had significantly reduced Heart Rate Variability (HRV).',
		Covid19_des_03: 'CoreCare system provides accurate QT prolongation and HRV with Stress level and Overall Heart Wellbeing among other essential parameters.',
		phone_title: 'Wearable ECG Sensors for iOS and Android',
		CB11_img_alt: 'CB11 Handheld Type Monitor Front and Back',
		CB12_img_alt: 'CB12 Handheld Type Monitor Front and Back',
		phones3_alt: 'iphone and pixel showing app screen',
		phone_screens_alt: 'phone screens showing QT prolongation and HRV with Stress level',
		CB11_patchAdhesive_alt: 'CB11 Patch Type Monitor'
	},

	CB11: {
		title: 'CB11',
		description: 'Patch Type ECG Monitor',
		highlight_1: 'Medical grade long-term cardiac monitoring.',
		highlight_1_1: ' ',
		highlight_2: 'Up to 15 days of continuous Mobile Cardiac Telemetry (MCT) without charging.',
		highlight_3: 'Low power Bluetooth connection to iOS and Android devices.',
		highlight_4: 'Light weight and simple to use.',
		electronic: 'ECG Sensor',
		battery: 'Battery',
		holder: 'Holder',
		electrode : 'Disposable Electrodes',
		specification: 'Technical Specifications',
		dimension: 'Dimensions',
		dimension_value: '36.4mm x 36.4mm x 8.2mm',
		weight: 'Weight with Battery',
		weight_value: '8.7 grams',
		range: 'HR Range',
		rang_value: '30~240 bpm',
		input: 'Input Dynamic Range',
		input_value: '±5 mV',
		frequency: 'Frequency Response',
		frequency_value: '0.67-40 Hz (-3dB)',
		rate: 'Sampling Rate',
		rate_value: '250 Hz',
		battery_type: 'Battery Type',
		battery_type_value: 'CR2032, DC3V',
		connect: 'Connectivity',
		connect_value: 'Bluetooth Low Energy',
		electronic_alt: 'CB11 cardiac monitor',
		battery_alt: 'CR2032 battery',
		holder_alt: 'electrode holder',
		electrode_alt: 'disposable electrode',
		No_Adhesiv_alt: 'CB11 patch',
		ecordum_logo_alt: 'ecordum logo'
	},

	CB11var: {
		title: 'CB11',
		description: 'Handheld ECG Monitor',
		highlight_1: 'Medical grade intermittent cardiac monitoring.',
		highlight_2: 'Compact and simple to use.',
		highlight_3: 'Takes a 30-180 second ECG recording.',
		highlight_4: 'Low power Bluetooth connection to iOS and Android devices.',
		highlight_5: 'CB11 patch monitor can be easily converted to the handheld ECG monitor, by replacing the adhesive gel electrode holder with steel electrodes.',
		highlight_5_1: ' ',
		electronic: 'ECG Sensor',
		battery: 'Battery',
		electrode : 'Steel Electrodes',
		specification: 'Technical Specifications',
		dimension: 'Dimensions',
		dimension_value: '36.4mm x 36.4mm x 8.2mm',
		range: 'HR Range',
		rang_value: '30~240 bpm',
		input: 'Input Dynamic Range',
		input_value: '±5 mV',
		frequency: 'Frequency Response',
		frequency_value: '0.67-40 Hz (-3dB)',
		rate: 'Sampling Rate',
		rate_value: '250 Hz',
		battery_type: 'Battery Type',
		battery_value: 'CR2032, DC3V',
		connect: 'Connectivity',
		connect_value: 'Bluetooth Low Energy',
		handheld_front: 'CB11 handheld front',
		handheld_back: 'CB11 handheld back'
	},

	CB11Handheld: {
		featuresInfo_1: 'Medical grade intermittent cardiac monitoring.',
		featuresInfo_2_1: 'Compact and simple to use.',
		featuresInfo_2_2: 'Takes a 30-180 second ECG recording.',
		featuresInfo_3: 'Low power Bluetooth connection to iOS and Android devices.',
		technical_specs: 'Technical Specifications',
		specInfo_title_1: 'Dimensions',
		specInfo_detail_1: '36.4mm x 36.4mm x 8.2mm',
		specInfo_title_2: 'Weight with Battery',
		specInfo_detail_2: '8.7 grams',
		specInfo_title_3: 'Dimensions',
		specInfo_detail_3: '36.1mm x 36.1mm x 4.65mm',
		specInfo_title_4: 'Weight - Handheld Electrode',
		specInfo_detail_4: '4.7 grams',
		specInfo_title_5: 'HR Range',
		specInfo_detail_5: '30~240 bpm',
		specInfo_title_6: 'Input Dynamic Range',
		specInfo_detail_6: '±5 mV',
		specInfo_title_7: 'Frequency Response',
		specInfo_detail_7: '0.67-40 Hz (-3dB)',
		specInfo_title_8: 'Sampling Rate',
		specInfo_detail_8: '250 Hz',
		specInfo_title_9: 'Battery Type',
		specInfo_detail_9: 'CR2032, DC3V',
		specInfo_title_10: 'Connectivity',
		specInfo_detail_10: 'Low Power Bluetooth',
		specInfo_title_11: 'Onboard Storage',
		specInfo_detail_11: 'One Hour Data (Optional)',
		specInfo_title_12: '3-Axes Accelerometer',
		specInfo_detail_12: '±2g (Optional)'
	},

	CB12: {
		title: 'CB12',
		description: 'Handheld ECG Monitor',
		highlight_1: 'Medical grade intermittent cardiac monitoring.',
		highlight_2: 'Light weight and simple to use.',
		highlight_3: 'Takes a 30-180 second ECG recording.',
		highlight_4: 'Low power Bluetooth connection to iOS and Android devices.',
		specification: 'Technical Specifications',
		technical_specs: 'Technical Specifications',
		dimension: 'Dimensions',
		dimension_value: '91mm x 46mm x 5mm',
		range: 'HR Range',
		rang_value: '30~240 bpm',
		input: 'Input Dynamic Range',
		input_value: '±5 mV',
		frequency: 'Frequency Response',
		frequency_value: '0.67-40 Hz (-3dB)',
		rate: 'Sampling Rate',
		rate_value: '250 Hz',
		battery_type: 'Battery Type',
		battery_type_value: 'CR2032, DC3V',
		connect: 'Connectivity',
		connect_value: 'Bluetooth Low Energy',
		front_alt: 'CB12 handheld fron'
	},

	setting: {
		login: 'Sign In',
		monitors: 'MONITORS',
		contactus: 'CONTACT US',
		product_CB11: 'CB11 Patch',
		product_CB11_var: 'CB11 Handheld',
		product_CB12: 'CB12 Handheld',
		contact_us: 'Contact Us',
		english: 'English',
		first_name: 'First Name',
		first_name_notice1: 'The name must consist of alphabetic characters only.',
		first_name_notice2: 'First name must be at least 2 characters long.',
		first_name_notice3: 'First name can be no more than 30 characters long.',
		first_name_notice4: 'Please enter your first name',
		last_name: 'Last Name',
		last_name_notice1: 'The name must consist of alphabetic characters only.',
		last_name_notice2: 'Last name must be at least 2 characters long.',
		last_name_notice3: 'Last name can be no more than 30 characters long.',
		last_name_notice4: 'Please enter your last name',
		name: 'Name',
		phone: 'Phone',
		email: 'Email',
		email_notice1: 'Email address is not valid.',
		email_notice2: 'Please enter your email address.',
		message: 'Message',
		message_notice1: 'Message must be at least 20 characters long.',
		message_notice2: 'Please enter your message.',
		required: 'Required',
		cancel: 'Cancel',
		send: 'Send',
		fail_error: 'Oops! Something went wrong and your message was not sent!',
		more: 'LEARN MORE',
		footer1: 'FDA 510(k) Number: K222842',
		footer2: 'NMPA (former CFDA) certified',
		contact: 'Email Inquiries: info@eCordum.cn',
		contact1: 'Customer Service',
		contact2: 'WeChat', 
		copyright: 'Copyright © 2015-2026 CoreCare Technologies. All rights reserved.',
		caseNumber: ' ',
		certificate: ' ',
		English: '中文',
		Chinese: 'English'
	}
};

export default en;